import React, {useEffect, useState} from "react"
import {Button, Col, Divider, Form, Input, Row, Table, Select} from "antd"

import common from "../../../../utils/common"
import moment from "moment";
import PageTop from "../../../../components/layout/PageTop";
import {SaveOutlined} from "@ant-design/icons";
import {Coupon, Ticket} from "../../../../components/coupon/config";

function AppliedForm(props) {
    let {defaultValue, onOk} = props

    let [typeIsOther, setTypeIsOther] = useState(false)
    let [number, setNumber] = useState(0)

    const [form] = Form.useForm()
    const {Item: FormItem} = Form

    // 表单提交
    let onFinish = (values) => {
        onOk({
            ownerId: common.getUser().company.id,
            spec: values.spec,
            type: values.type,
            ids: defaultValue.map(item => item.id)
        })
    }

    const columns2 = [
        {
            title: '编号名称',
            dataIndex: 'code',
            width: 200,
            ellipsis: true,
        },
        {
            title: '卡券名称',
            dataIndex: ['couponDto', 'name'],
            width: 200,
            ellipsis: true,
        },
        {
            title: '客户名称',
            dataIndex: 'customerName',
            width: 200,
            ellipsis: true,
        },
        {
            title: '预收金额',
            dataIndex: ["couponDto", 'price'],
            width: 200,
            ellipsis: true,
        },
        {
            title: '最大抵扣金额',
            dataIndex: ["couponDto", 'reduceMax'],
            width: 200,
            ellipsis: true,
        },
    ];

    useEffect(() => {
        defaultValue.forEach((item) => {
            if (item.couponDto.category1 === Coupon.CATEGORY1_ADVANCE) {
                setNumber(1)
            }
        })
    }, [defaultValue])

    return (
        <>
            <br/>
            <PageTop title={'卡券核销'}>
                <Button
                    icon={<SaveOutlined/>}
                    type={"primary"}
                    onClick={() => {
                        form.submit()
                    }}>保存</Button>
            </PageTop>
            <Form
                form={form}
                className={'ant-advanced-inline-form label-character-4'}
                initialValues={{
                    people: common.getUser().nickname,
                    time: moment(new Date().toLocaleDateString(), "YYYY/MM/DD").format('YYYY-MM-DD'),
                }}
                onFinish={onFinish}
            >
                <Row gutter={24}>
                    <Col span={8}>
                        <FormItem
                            name={'type'}
                            rules={[{required: true, message: '核销原因不允许为空'}]}
                            label={'核销原因'}
                        >
                            <Select onChange={(val) => {
                                setTypeIsOther(val === Ticket.APPLIED_TYPE_OTHER)
                            }}>
                                <Select.Option value={Ticket.APPLIED_TYPE_REPEAT}
                                               key={Ticket.APPLIED_TYPE_REPEAT}>{Ticket.AppliedTypeAlias[Ticket.APPLIED_TYPE_REPEAT]}</Select.Option>
                                <Select.Option value={Ticket.APPLIED_TYPE_GIVE_UP}
                                               key={Ticket.APPLIED_TYPE_GIVE_UP}>{Ticket.AppliedTypeAlias[Ticket.APPLIED_TYPE_GIVE_UP]}</Select.Option>
                                <Select.Option value={Ticket.APPLIED_TYPE_OVERDUE_HAND}
                                               key={Ticket.APPLIED_TYPE_OVERDUE_HAND}>{Ticket.AppliedTypeAlias[Ticket.APPLIED_TYPE_OVERDUE_HAND]}</Select.Option>
                                <Select.Option value={Ticket.APPLIED_TYPE_OTHER}
                                               key={Ticket.APPLIED_TYPE_OTHER}>{Ticket.AppliedTypeAlias[Ticket.APPLIED_TYPE_OTHER]}</Select.Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span={8}>
                        <FormItem
                            name={'people'}
                            rules={[{required: true, message: '操作人不允许为空'}]}
                            label={'操作人'}
                        >
                            <Input disabled={true}/>
                        </FormItem>
                    </Col>
                    <Col span={8}>
                        <FormItem
                            name={'time'}
                            rules={[{required: true, message: '操作时间不允许为空'}]}
                            label={'操作时间'}
                        >
                            <Input disabled={true}/>
                        </FormItem>
                    </Col>
                </Row>

                <Row gutter={24}>
                    <Col span={24}>
                        <FormItem
                            name={'spec'}
                            rules={typeIsOther ? [{
                                required: true,
                                message: '核销备注不允许为空'
                            }] : []}
                            label={'核销备注'}
                        >
                            <Input/>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <Divider orientation="left">卡券({defaultValue.length})</Divider>
            <Table
                rowKey={'id'}
                pagination={false}
                dataSource={defaultValue}
                columns={columns2}
                scroll={{x: '100%'}}
            />
            {number > 0 &&
            <div style={{color: 'red', marginTop: '5px'}}>提醒: 核销券中包含为预收款的卡券，如果进行核销会同时减少该客户的预收款。</div>}
        </>

    )
}

export default AppliedForm